import { ReactNode } from 'react';
import { create } from 'zustand';

// zustand 전역 상태 구조
interface ToastState {
    open: boolean;
    message: ReactNode;
    duration: number;
    type: ToastType;
    showToast: (msg: ReactNode, d?: number, t?: ToastType, custom?: boolean) => void;
    hideToast: () => void;
    isCustom: boolean;
    customChild?: ReactNode;
}

// 전역 스토어 생성 (zustand)
export const useToastStore = create<ToastState>((set) => ({
    open: false,
    message: '',
    duration: 2000,
    type: 'save',
    showToast: (msg, d = 2000, t = 'save', custom = false) =>
        set({
            open: true,
            message: msg,
            type: t,
            duration: d,
            isCustom: custom,
        }),
    hideToast: () =>
        set({
            open: false,
            message: '',
            type: 'save',
        }),
    isCustom: false,
}));
